import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import {
  BreakpointObserver,
  Breakpoints,
  MediaMatcher,
} from '@angular/cdk/layout';
import { NavbarService } from '../services/navbar.service';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { UnsavedChangesService } from '../services/unsaved-changes.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css'],
})
export class MainNavComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav;

  mobileQuery: MediaQueryList;
  opened: boolean;

  showSubmenu: boolean = false;
  isShowing = false;
  isExpanded = true;
  isSaidMenu = true;

  customerShowSubmenu: boolean = false;
  customerisShowing = false;
  customerisExpanded = true;

  moratgeShowSUbmenu: boolean = false;
  mortageIsShowing = false;
  mortageIsExpanded = true;

  realEstateShowSubmenu: boolean = false;
  realEstateIsExpanded = true;
  realEstateIsShowing = false;

  private _mobileQueryListener: () => void;
  
  constructor(
    public nav: NavbarService,
    private changeDetectorRef: ChangeDetectorRef,
    public route: Router,
    media: MediaMatcher,
    private dialog: MatDialog,
    private unsavedChangesService: UnsavedChangesService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.nav.show();
  }

  navigateWithReload(path: string): void {
    this.sidenav.close();
    this.route.navigate([path]).then(() => {
      window.location.reload();
    });
  }

  logOut() {
    if (this.unsavedChangesService.hasUnsavedChanges) {
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        width: '420px',
        disableClose: true,
        data: {
          title: 'Unsaved Changes',
          message: 'You have unsaved changes. Do you want to save before logging out?',
          confirmStatus: true,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed && this.unsavedChangesService.saveAll) {
          // Save all sections, then logout
          this.unsavedChangesService.saveAll().subscribe({
            next: () => this.performLogout(),
            error: () => this.performLogout(),
          });
        } else {
          // Discard and logout
          this.performLogout();
        }
      });
    } else {
      this.performLogout();
    }
  }

  private performLogout(): void {
    this.unsavedChangesService.unregister();
    sessionStorage.clear();
    this.route.navigate(['/']);
    this.opened = false;
  }

  styleObject(): Object {
    if (this.showSubmenu == false) {
      return { display: 'none' };
    }
    return {};
  }

  customerSubmenuStyles(): Object {
    if (this.customerShowSubmenu == false) {
      return { display: 'none' };
    }
    return {};
  }

  mortageSubmenuStyles(): Object {
    if (this.moratgeShowSUbmenu == false) {
      return { display: 'none' };
    }
    return {};
  }

  realEstateSubmenuStyles(): Object {
    if (this.realEstateShowSubmenu == false) {
      return { display: 'none' };
    }
    return {};
  }
}
